import HeroSlider from "@/components/site/HeroSlider";
import EditorialMarquee from "@/components/site/Marquee";
import ProductGrid from "@/components/site/ProductGrid";
import Manifesto from "@/components/site/Manifesto";
import Contact from "@/components/site/Contact";

export default function Home() {
  return (
    <>
      <HeroSlider />
      <EditorialMarquee />
      <ProductGrid />
      <Manifesto />
      <Contact />
    </>
  );
}
